export interface PriceChartItem {
  date: number;
  price: number;
}
